import { forwardRef, useCallback, memo } from 'react';
import { RichTextEditor } from 'components/common/RichTextEditor';
import { ErrorPresentation } from 'helpers/validators';

interface StatefulRichTextFieldProps {
  value?: string;
  defaultValue?: string;
  handleChange?: (event: any, value: string) => void;
  onBlur?: () => void;
  error?: ErrorPresentation;
  disabled?: boolean;
  labelId?: string;
  fieldName?: string;
  dataQa?: string;
  maxLength?: number;
  minRows?: number;
  autoGrow?: boolean;
  dense?: boolean;
  placeholder?: string;
}

function StatefulRichTextField(
  {
    value,
    defaultValue,
    handleChange,
    onBlur,
    error,
    disabled,
    labelId,
    fieldName,
    dataQa,
    maxLength,
    minRows,
    autoGrow,
    dense,
    placeholder,
  }: StatefulRichTextFieldProps,
  ref: any
) {
  const onChange = useCallback(
    (html: string) => {
      handleChange?.(null, html);
    },
    [handleChange]
  );

  return (
    <RichTextEditor
      value={value}
      defaultValue={defaultValue}
      onChange={onChange}
      onBlur={onBlur}
      error={Boolean(error)}
      disabled={disabled}
      labelId={labelId}
      fieldName={fieldName}
      dataQa={dataQa}
      maxLength={maxLength}
      minRows={minRows}
      autoGrow={autoGrow}
      dense={dense}
      placeholder={placeholder}
    />
  );
}

export default memo(forwardRef(StatefulRichTextField));
